export interface IExceptionalDaysItem {
    expectedShippingDate: string;
    expectedArrivalDate: string;
}

export interface IExceptionalDays {
    [date: string]: IExceptionalDaysItem;
}

const aprCycle1Item = {
    expectedShippingDate: '2022/05/02',
    expectedArrivalDate: '2022/05/03',
}

const aprCycle1 = {
    '2022/04/25': aprCycle1Item,
    '2022/04/26': aprCycle1Item,
}

const aprCycle2Item = {
    expectedShippingDate: '2022/05/10',
    expectedArrivalDate: '2022/05/11',
}

const aprCycle2 = {
    '2022/04/27': aprCycle2Item,
    '2022/04/28': aprCycle2Item,
    '2022/04/29': aprCycle2Item,
    '2022/04/30': aprCycle2Item,
    '2022/05/01': aprCycle2Item,
}

const mayCycle1Item = {
    expectedShippingDate: '2022/05/11',
    expectedArrivalDate: '2022/05/12',
}

const mayCycle1 = {
    '2022/05/02': mayCycle1Item,
    '2022/05/03': mayCycle1Item,
    '2022/05/04': mayCycle1Item,
    '2022/05/05': mayCycle1Item,
    '2022/05/06': mayCycle1Item,
}

const mayCycle2Item = {
    expectedShippingDate: '2022/05/16',
    expectedArrivalDate: '2022/05/17',
}

const mayCycle2 = {
    '2022/05/07': mayCycle2Item,
    '2022/05/08': mayCycle2Item,
    '2022/05/09': mayCycle2Item,
    '2022/05/10': mayCycle2Item,
    '2022/05/11': mayCycle2Item,
}

const julCycle1Item = {
    expectedShippingDate: '2022/07/19',
    expectedArrivalDate: '2022/07/20',
}

const julCycle1 = {
    '2022/07/11': julCycle1Item,
    '2022/07/12': julCycle1Item,
    '2022/07/13': julCycle1Item,
}

const julCycle2Item = {
    expectedShippingDate: '2022/07/21',
    expectedArrivalDate: '2022/07/22',
}

const julCycle2 = {
    '2022/07/14': julCycle2Item,
    '2022/07/15': julCycle2Item,
    '2022/07/16': julCycle2Item,
    '2022/07/17': julCycle2Item,
}


const augustCycle1Item = {
    expectedShippingDate: '2022/08/16',
    expectedArrivalDate: '2022/08/17',
}

const augustCycle1 = {
    '2022/08/08': augustCycle1Item,
    '2022/08/09': augustCycle1Item,
    '2022/08/10': augustCycle1Item,
}

const septemberCycle1Item = {
    expectedShippingDate: '2022/09/20',
    expectedArrivalDate: '2022/09/21',
}

const septemberCycle1 = {
    '2022/09/12': septemberCycle1Item,
    '2022/09/13': septemberCycle1Item,
    '2022/09/14': septemberCycle1Item,
}

const septemberCycle2Item = {
    expectedShippingDate: '2022/09/22',
    expectedArrivalDate: '2022/09/23',
}

const septemberCycle2 = {
    '2022/09/15': septemberCycle2Item,
    '2022/09/16': septemberCycle2Item,
    '2022/09/17': septemberCycle2Item,
    '2022/09/18': septemberCycle2Item,
}

const septemberCycle3Item = {
    expectedShippingDate: '2022/09/27',
    expectedArrivalDate: '2022/09/28',
}

const septemberCycle3 = {
    '2022/09/19': septemberCycle3Item,
    '2022/09/20': septemberCycle3Item,
    '2022/09/21': septemberCycle3Item,
}

const octoberCycle1Item = {
    expectedShippingDate: '2022/10/11',
    expectedArrivalDate: '2022/10/12',
}

const octoberCycle1 = {
    '2022/10/03': octoberCycle1Item,
    '2022/10/04': octoberCycle1Item,
    '2022/10/05': octoberCycle1Item,
}

const octoberCycle2Item = {
    expectedShippingDate: '2022/10/13',
    expectedArrivalDate: '2022/10/14',
}

const octoberCycle2 = {
    '2022/10/06': octoberCycle2Item,
    '2022/10/07': octoberCycle2Item,
    '2022/10/08': octoberCycle2Item,
    '2022/10/09': octoberCycle2Item,
}

const novemberCycle1Item = {
    expectedShippingDate: '2022/11/08',
    expectedArrivalDate: '2022/11/09',
}

const novemberCycle1 = {
    '2022/10/31': novemberCycle1Item,
    '2022/11/01': novemberCycle1Item,
    '2022/11/02': novemberCycle1Item,
}

const novemberCycle2Item = {
    expectedShippingDate: '2022/11/24',
    expectedArrivalDate: '2022/11/25',
}

const novemberCycle2 = {
    '2022/11/17': novemberCycle2Item,
    '2022/11/18': novemberCycle2Item,
    '2022/11/19': novemberCycle2Item,
    '2022/11/20': novemberCycle2Item,
}

//New cycles
const januaryCycle1Item = {
    expectedShippingDate: '2023/01/06',
    expectedArrivalDate: '2023/01/07',
}

const januaryCycle1 = {
    '2022/12/26': januaryCycle1Item,
    '2022/12/27': januaryCycle1Item,
    '2022/12/28': januaryCycle1Item,
    '2022/12/29': januaryCycle1Item,
    '2022/12/30': januaryCycle1Item,
    '2022/12/31': januaryCycle1Item,
    '2023/01/01': januaryCycle1Item,
    '2023/01/02': januaryCycle1Item,
}

const januaryCycle2Item = {
    expectedShippingDate: '2023/01/11',
    expectedArrivalDate: '2023/01/12',
}

const januaryCycle2 = {
    '2023/01/03': januaryCycle2Item,
    '2023/01/04': januaryCycle2Item,
    '2023/01/05': januaryCycle2Item,
}

const januaryCycle3Item = {
    expectedShippingDate: '2023/01/12',
    expectedArrivalDate: '2023/01/13',
}

const januaryCycle3 = {
    '2023/01/06': januaryCycle3Item,
    '2023/01/07': januaryCycle3Item,
    '2023/01/08': januaryCycle3Item,
}


export const exceptionalDays: IExceptionalDays = {
    ...aprCycle1,
    ...aprCycle2,
    ...mayCycle1,
    ...mayCycle2,
    ...julCycle1,
    ...julCycle2,
    ...augustCycle1,
    ...septemberCycle1,
    ...septemberCycle2,
    ...septemberCycle3,
    ...octoberCycle1,
    ...octoberCycle2,
    ...novemberCycle1,
    ...novemberCycle2,
    ...januaryCycle1,
    ...januaryCycle2,
    ...januaryCycle3,
};

/** array of exceptional cycles */
export const exceptionalDaysArr: IExceptionalDays[] = [
    aprCycle1,
    aprCycle2,
    mayCycle1,
    mayCycle2,
    julCycle1,
    julCycle2,
    augustCycle1,
    septemberCycle1,
    septemberCycle2,
    septemberCycle3,
    octoberCycle1,
    octoberCycle2,
    novemberCycle1,
    novemberCycle2,
    januaryCycle1,
    januaryCycle2,
    januaryCycle3,
];
